import type { FaireProductEntity } from "../../entity_types/product";

export const p_5ghpp1m8: FaireProductEntity = {
  token: "p_5ghpp1m8",
  type: "product",
  name: "Sea Salt Surf 9oz Soy Candle",
  brandToken: "b_awt663at",
  brandName: "Broken Top Brands",
  imageUrl:
    "https://cdn.faire.com/fastly/d5835ca3108656159f07834c7d956d530f91481a0d6df3cc523d75b3578fc6cb.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/458ab9c78018f3345b27bd53b9efe2e5bc237c1740a0987f2d381d88985aa6da.png",
    "https://cdn.faire.com/fastly/b76e46ec14c0ff31478a2f71255b46ff4c7541d8942f3d1c66772a8121d21626.jpeg",
    "https://cdn.faire.com/fastly/32596b1924fea1cb7a7326a2508cd9d023992d7ed67c02e27f7ebe6451e58fef.jpeg",
    "https://cdn.faire.com/fastly/1419d44b9b127b974323e34b8ac3d3dcca614cdef959aafa69cdce438c62a92d.jpeg",
    "https://cdn.faire.com/fastly/7b960772362a20a7cf712a7761ab89c00c17f9d0ee7e5b2db457be28c35c88a4.jpeg",
    "https://cdn.faire.com/fastly/39a8e35711a4145cd6865cb92de87dda999ddf87cd609a722689b058c6415193.jpeg",
  ],
  priceDollars: 13,
  description:
    "Wood | Cream | Jasmine\n\nFresh, airy, and effortlessly coastal — Sea Salt Surf captures the essence of a morning walk along the shoreline, sea salt lingering in the breeze. Soft jasmine and creamy sweetness meet warm driftwood for a scent that’s both relaxing and alluring. Hand-poured in Bend, Oregon, this 9 oz soy candle delivers a 50-hour burn with a smooth, even melt.\n\n• Hand-poured in Bend, Oregon\n• Clean-burning soy wax blend\n• 50-hour burn time\n• Vegan, paraben-free, phthalate-free\n• Ideal for living areas + bathrooms\n\nsea salt candle, coastal candle, jasmine candle, driftwood candle, handmade, soy candle, home fragrance, giftable candle, hostess gift, holiday candle, beach candle, cozy home scent, candles wholesale, valentines day, valentines, valentine, valentines day gifts, valentine gifts, valentines gifts, valentine decor, valentine candles, heart, hearts, gifts, gift, handmade, made in USA",
  tags: [],
  msrpDollars: 26,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:47:57.268Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
